import { ColorScheme } from 'owa-graph-schema';

export default ColorScheme;

/**
 * Function to convert ColorScheme into color and backgroundColor CSS properties with the calPrimary scheme color.
 */
export function colorSchemeToCss(scheme: ColorScheme): React.CSSProperties {
    return {
        backgroundColor: scheme.calPrimary,
        color: scheme.accessibleText ? scheme.accessibleText.calPrimaryBackground : scheme.text,
    };
}

/**
 * Function to convert ColorScheme into color and backgroundColor CSS properties for the calendar surface with the calLight scheme color.
 */
export function colorSchemeToDarkCss(scheme: ColorScheme): React.CSSProperties {
    return {
        backgroundColor: scheme.calDarkAlt,
        color: scheme.accessibleText ? scheme.accessibleText.calPrimaryBackground : scheme.text,
    };
}

/**
 * Function to convert ColorScheme into color and backgroundColor CSS properties for the calendar surface with the calLight scheme color.
 */
export function colorSchemeToInvertCss(scheme: ColorScheme): React.CSSProperties {
    return {
        backgroundColor: scheme.calLighter,
        color: scheme.accessibleText ? scheme.accessibleText.calLighterBackground : scheme.textAlt,
    };
}

/**
 * Function to convert ColorScheme into color and backgroundColor CSS properties for the calendar surface with the calLight scheme color.
 */
export function colorSchemeToMediumCss(scheme: ColorScheme): React.CSSProperties {
    return {
        backgroundColor: scheme.calLight,
        color: scheme.accessibleText ? scheme.accessibleText.calPrimaryBackground : scheme.text,
    };
}

/**
 * Function to convert ColorScheme into color and backgroundColor CSS properties for the calendar surface with the calLight scheme color.
 */
export function colorSchemeToLightCss(scheme: ColorScheme): React.CSSProperties {
    return {
        backgroundColor: scheme.calLighter,
        color: scheme.accessibleText ? scheme.accessibleText.calPrimaryBackground : scheme.text,
    };
}

// Exporting these types to avoid import replacements in ~500 files. The import replacements will be done as a seperate PR
export { ColorScheme };
export { AccessibleTextScheme } from 'owa-graph-schema';
